module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft-f5616b43c2b20dd0f10b74b7bdf419e8.png";